import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export interface IProfessionalSituationDeleteMutationParameters {
    professionalSituation: RelationalValue<IProfessionalSituationResource>;
}

export type IProfessionalSituationDeleteMutationResult = void;

export const professionalSituationDeleteMutation: IApiMutationFunction<
    IProfessionalSituationDeleteMutationParameters
> = ({ professionalSituation }) => ({
    method: "DELETE",
    url: `/professional_situations/${mapRelationalValue(professionalSituation)}`,
});

export const useProfessionalSituationDeleteMutation = createApiMutationHook<
    IProfessionalSituationDeleteMutationParameters,
    IProfessionalSituationDeleteMutationResult
>(professionalSituationDeleteMutation);
